import { useEffect, useState } from "react";
import Sidebar from "../components/SidebarUpdate";
import Breadcrumb from "../components/Breadcrumb";
import { useLocation, useNavigate } from "react-router-dom";
import dummy_image from "../assest/images/dummy_image.jpg";
import apiInstance from "../apiConfig/apiinstance";

const MsrCategoryStyle = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [categoryStyle, setCategoryStyle] = useState([]);
  const location = useLocation();

  const slug = location.pathname.split("/").slice(-1)[0];
  console.log("slug in msr category style - ", slug);

  const fetchCategoryStyles = async (slug) => {
    setLoading(true);
    setError(null);

    try {
      const { data } = await apiInstance.get(
        `/api/msr/v1/get-season-style/${slug}`
      );
      // console.log("msr category styles", data);
      if (data.status === 200) {
        if (!data?.data?.length) {
          setError("No MSR category styles found");
          setCategoryStyle([]);
        } else {
          setCategoryStyle(data.data);
        }
      }
    } catch (error) {
      setError(
        error?.response?.data?.message || "Error fetching msr category styles"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategoryStyles(slug);
  }, [slug]);

  const handleCategoryChange = (newPath) => {
    navigate(newPath);
  };

  return (
    <div className="parent_Container">
      <div className="content_wrapper py-4 px-8">
        <Sidebar logo="FP ONE" />
        <div className="content_wrapper_child overflow-hidden">
          <div className="separator"></div>
          <Breadcrumb onCategoryClick={handleCategoryChange} isMSR={true} />
          {/* <h1>MSR Styles</h1> */}
          <div className="p-4">
            {loading ? (
              <div className="loader-container">Loading styles...</div>
            ) : categoryStyle.length === 0 ? (
              <div className="no-products loader-container">
                No Products Found
              </div>
            ) : (
              <div className="flex gap-y-4 sm:gap-4  flex-wrap">
                {categoryStyle.map((item) => (
                  <div
                    key={item.style_id}
                    onClick={() =>
                      navigate(`/msr-seasons/product-detail/${item.style_id}`)
                    }
                  >
                    <div className="image-container  cursor-pointer">
                      <img
                        src={item.cover_image || dummy_image}
                        className="image"
                        alt={`${item.name}`}
                      />
                      {/* <span className="text-2xl">{item.name}</span> */}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MsrCategoryStyle;
